import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconLink = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase
      width={props.width || 16}
      height={props.height || 16}
      viewBox={props.viewBox || '0 0 16 16'}
      fill={props.fill || 'none'}
    >
      <path
        d="M4.66675 4.66675H11.3334V11.3334"
        stroke={props.stroke || theme.colors.background.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66675 11.3334L11.3334 4.66675"
        stroke={props.stroke || theme.colors.background.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
